var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 90,
    viewBox: "0 0 58 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 86.548L1.95356 88.9319L3.5201 89L3.86066 86.2755L6.92568 86.548L8.42413 87.8421L9.10524 85.5263L13.5325 86.0031L17.6873 88.3189L18.709 86.0031L22.5232 84.3684L25.7925 87.2291L27.5634 85.5944V82.6656L31.0371 80.6223L32.9443 83.7554L37.7121 83.8916L38.6656 78.5108L41.322 77.8297L45.9535 72.517L45.6811 68.7028L55.8978 66.9319L55.3529 61.2105L56.5789 59.9164V1H10.3312L10.5356 54.6718L8.35602 59.9845L10.7399 68.3623L4.95044 78.3065L2.97521 78.3746L2.49843 79.805L3.58822 80.8948L1 86.548Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.8d68b575bd154360ce7b03b4bc1f948f.svg";
export { ForwardRef as ReactComponent };